/**
 * ConfigurationContext: App-wide configuration settings
 * Provides branding, logos, and app metadata
 */
import { createContext, useContext, ReactNode } from 'react';

interface ConfigurationContextType {
  title: string;
  darkModeLogo: string;
  lightModeLogo: string;
}

const ConfigurationContext = createContext<ConfigurationContextType>({
  title: 'AMS by Orca',
  darkModeLogo: '/orca-logo-dark.png',
  lightModeLogo: '/orca-logo-light.png',
});

export const ConfigurationProvider = ({ children }: { children: ReactNode }) => {
  const config = {
    title: 'AMS by Orca',
    darkModeLogo: '/orca-logo-dark.png',
    lightModeLogo: '/orca-logo-light.png',
  };

  return (
    <ConfigurationContext.Provider value={config}>
      {children}
    </ConfigurationContext.Provider>
  );
};

export const useConfigurationContext = () => {
  return useContext(ConfigurationContext);
};